import { render, staticRenderFns } from "./ConversationActionsBox.vue?vue&type=template&id=1bae9f15&scoped=true&"
import script from "./ConversationActionsBox.vue?vue&type=script&lang=js&"
export * from "./ConversationActionsBox.vue?vue&type=script&lang=js&"
import style0 from "./ConversationActionsBox.vue?vue&type=style&index=0&id=1bae9f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae9f15",
  null
  
)

export default component.exports